export const privatePersonID = 25;
export const limitedLiabilityCompanyID = 6;
